import { StepPackage } from '@samelogic/steps';

type StepImport = { default: StepPackage };

/**
 * PackageRepository is used to retreive the step package and verify it is
 * a valid package.
 */
export class RemotePackageRepository {
  /**
   *
   * @param url - Retreives the package by URL and verify it is a valid StepPackage
   */
  public async getPackageByUrl(url: string): Promise<StepPackage> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const stepImport: StepImport = await import(/* webpackIgnore: true */ url);

    this.validate(stepImport);

    return stepImport.default;
  }

  /**
   * Verifies that an imported step is valid.
   * @param stepImport - The step package to validate
   */
  private validate(stepImport: StepImport) {
    if (!stepImport.default) throw Error('Imported file has no default export');
    if (!stepImport.default.module || !stepImport.default.schema)
      throw Error('module or schema not found on default export');
  }
}
